import styled from "styled-components";
import { getHexTransparencyColor } from "@crehana/ui";
export var FutureLiveCardContainer = /*#__PURE__*/styled.article.withConfig({
  componentId: "sc-1i3p9mc-0"
})(["\n  height: 378px;\n  ", " {\n    height: 308px;\n  }\n  ", " {\n    height: 380px;\n  }\n"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up('sm');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up('md');
});
export var FutureLiveCardOverlay = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1i3p9mc-1"
})(["\n  background-image: linear-gradient(\n    180deg,\n    ", " 0%,\n    ", " 76.37%,\n    ", " 88.38%\n  );\n"], function (_ref3) {
  var theme = _ref3.theme;
  return getHexTransparencyColor(theme.colors.base.main, 0);
}, function (_ref4) {
  var theme = _ref4.theme;
  return getHexTransparencyColor(theme.colors.base.main, 80);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.base.main;
});